import React, { useContext } from 'react';

import { Navigate } from 'react-router-dom';

import { useProfileData } from '../../hooks';
import { useScoreQuery } from '../../hooks/useScoreQuery';
import { PageContext } from '../../routes/Page';
import { isEmptyObject } from '../../utils';
import { Loader } from '../Loader';
import { MainLayout } from '../MainLayout';

/**
 *
 */
const filterExcludedSections = (sections: any, excludeIds: string[]) => {
    return sections.filter((section: any) =>
        excludeIds.every((excludedId) => excludedId !== section.id),
    );
};

/**
 * Order might not have order of every possible section,
 * in that case we're displaying only sections which are part of the `order`
 * array.
 */
const changeSectionOrder = (sections: any, orderIds: string[]) => {
    return sections
        .filter((section: any) => orderIds.includes(section.id))
        .sort(
            (a: any, b: any) => orderIds.indexOf(a.id) - orderIds.indexOf(b.id),
        );
};

export const LayoutScore: React.FC = ({ children }) => {
    const scoreQuery = useScoreQuery();
    const scoreData = scoreQuery.data;
    const { profileData } = useProfileData();

    const { currentUser, currentPageData, setCurrentPageData } =
        useContext(PageContext);

    // useEffect(() => {
    // if (!scoreData || isEmptyObject(scoreData)) return;

    /**
     * This exclude order thing is exclusive for MyScore Page
     * for now. If you ever would like to display other pages
     * sections conditionally we would  simply need to move
     * the config to profile API and add section ID to every
     * section that is used in the Storyblok
     */

    // if (scoreData.sections) {
    //     const { exclude, order } = scoreData.sections;

    //     const filteredSections = filterExcludedSections(
    //         currentPageData?.content.sections,
    //         exclude,
    //     );

    //     /**
    //      * The `order` might be just an empty array we need
    //      * to check its length first.
    //      * If it ISN'T an empty array then we are displaying
    //      * ONLY ordered sections to the user.
    //      */
    //     setCurrentPageData({
    //         ...currentPageData,
    //         content: {
    //             ...currentPageData.content,
    //             sections:
    //                 order.length > 0
    //                     ? changeSectionOrder(filteredSections, order)
    //                     : filteredSections,
    //         },
    //     });
    // }
    // }, [scoreData]);

    const { hide_footer: hideFooter } = currentPageData.content;

    if (scoreQuery.isLoading) {
        return <Loader centered />;
    }

    if (!currentUser || (scoreQuery.data && isEmptyObject(scoreQuery.data))) {
        return <Navigate to="/check-score" />;
    }

    return <MainLayout hideFooter={hideFooter}>{children}</MainLayout>;
};
